<template>
  <v-container fluid style="height: 100%">
    <v-container
      fluid
      v-if="!hasLoadingError"
      class="pa-4 fill-height align-start"
    >
      <v-row>
        <v-col>
          <v-row>
            <v-col cols="12" md="8" lg="9">
              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{
                      currentRouteName !== "EmployeeBasicProfile"
                        ? $t("user.profile.employeeProfile")
                        : $t("navBarItems.profile")
                    }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-row>
                    <v-col cols="12" md="6">
                      <EmployeeProfileCard
                        @onError="snackbar = true"
                        @update="changeCommonCardValues"
                        :userData="userProfile"
                        :loading="loading"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      v-if="
                        userProfile &&
                        userProfile.employee &&
                        userProfile.employee._id
                      "
                    >
                      <EmployeeProfileProgressCard
                        :userId="userProfile.employee._id"
                        ref="progressCard"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("user.basicInfo") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <EmployeeBasicInfo
                    @onError="snackbar = true"
                    @update="changeCommonCardValues"
                    :userData="userProfile"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <ProfileQrCode
                v-if="!loading"
                :userProfile="userProfile"
                class="mb-10"
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              currentRouteName !== 'EmployeeBasicProfile' &&
              userProfile &&
              userProfile.employee &&
              userProfile.employee._id
            "
          >
            <v-col>
              <CoursesList
                :employeeId="userProfile.employee._id"
                :employeeOrganizationId="
                  userProfile.employee.organization
                    ? userProfile.employee.organization._id
                    : null
                "
                @onStatusUpdate="updateProgressCard"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="hasLoadingError" fluid class="fill-height">
      <Error />
    </v-container>

    <v-snackbar v-model="snackbar" timeout="3000">
      {{ $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Error from "../../core-module/components/Error.vue";
import EmployeeProfileCard from "../components/employee-profile/EmployeeProfileCard.vue";
import EmployeeProfileProgressCard from "../components/employee-profile/EmployeeProfileProgressCard.vue";
import EmployeeBasicInfo from "../components/employee-profile/EmployeeBasicInfo.vue";
import CoursesList from "../components/employee-profile/EmployeeCoursesList.vue";
import ProfileQrCode from "@/app/user-module/components/employee-profile/ProfileQrCode";

export default {
  components: {
    ProfileQrCode,
    Error,
    EmployeeBasicInfo,
    EmployeeProfileCard,
    CoursesList,
    EmployeeProfileProgressCard,
  },
  data() {
    return {
      snackbar: false,
      hasLoadingError: false,
      userProfile: {},
      loading: true,
    };
  },

  watch: {
    "$route.params.userId": {
      handler() {
        this.loading = true;
        if (!this.$route.params.userId) this.hasLoadingError = true;
        else {
          this.fetchProfile();
        }
      },
      immediate: true,
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    changeCommonCardValues() {
      this.fetchProfile();
    },
    updateProgressCard() {
      this.$refs.progressCard.refetch();
    },
    fetchProfile() {
      this.$apollo
        .query({
          query: require("../api/query/getProfile.gql"),
          variables: { id: this.$route.params.userId },
          fetchPolicy: "network-only",
        })
        .then(result => {
          this.loading = false;
          if (result?.data?.getProfile) {
            this.userProfile = result.data.getProfile;
          } else {
            this.hasLoadingError = true;
          }
        });
    },
  },
};
</script>
